import React from "react";
import "../Pricing.css";

function PricingBox2() {

    const comparisonData = [
        {
            feature: "Number of Customers",
            starter: "Unlimited",
            growth: "Unlimited",
            ultimate: "Unlimited",
        },
        {
            feature: "Number of Card Designs",
            starter: "1",
            growth: "Up to 3",
            ultimate: "Up to 5",
        },
        {
            feature: "Number of Stamper App Users",
            starter: "Up to 3",
            growth: "Up to 5",
            ultimate: "Up to 8",
        },
        {
            feature: "Maximum Locations Supported",
            starter: "1 Location",
            growth: "2 Locations",
            ultimate: "3 Locations",
        },
        {
            feature: "Compatible with Apple Wallet",
            starter: true,
            growth: true,
            ultimate: true,
        },
        {
            feature: "Compatible with Google Wallet",
            starter: true,
            growth: true,
            ultimate: true,
        },
        {
            feature: "Visual Card Designer (Web App)",
            starter: true,
            growth: true,
            ultimate: true,
        },
        {
            feature: "Upload Your Logo, Choose Colors",
            starter: true,
            growth: true,
            ultimate: true,
        },
        {
            feature: "Background Image Customization",
            starter: true,
            growth: true,
            ultimate: true,
        },
        {
            feature: "Remote Stamping / Web Stamper",
            starter: true,
            growth: true,
            ultimate: true,
        },
        {
            feature: "Single & Multi-Reward Card Options",
            starter: true,
            growth: true,
            ultimate: true,
        },
        {
            feature: "Unlimited Push Messages",
            starter: true,
            growth: true,
            ultimate: true,
        },
        {
            feature: "Lock Screen Notifications (iOS)",
            starter: true,
            growth: true,
            ultimate: true,
        },
        {
            feature: "Location-Based Messages (Geo-Fencing)",
            starter: true,
            growth: true,
            ultimate: true,
        },
        {
            feature: "Distribution QR Code & Direct Link",
            starter: true,
            growth: true,
            ultimate: true,
        },
        {
            feature: "Built-in Enrolment Forms",
            starter: true,
            growth: true,
            ultimate: true,
        },
        {
            feature: "Real Time Analytics & Reporting",
            starter: true,
            growth: true,
            ultimate: true,
        },
        {
            feature: "No-Code Integration (via Zapier/Make)",
            starter: true,
            growth: true,
            ultimate: true,
        },
        {
            feature: "Developer API Access",
            starter: true,
            growth: true,
            ultimate: true,
        },
        {
            feature: "Standard Customer Support",
            starter: true,
            growth: true,
            ultimate: true,
        },
        {
            feature: "Priority Customer Service",
            starter: false,
            growth: true,
            ultimate: true,
        },
        {
            feature: "Customizing Label Text",
            starter: false,
            growth: true,
            ultimate: true,
        },
        {
            feature: "Unique Customer Enrollment (Advanced)",
            starter: false,
            growth: false,
            ultimate: true,
        },
        {
            feature: "Data Export (CSV/Spreadsheet)",
            starter: false,
            growth: false,
            ultimate: true,
        },
    ];

    const renderValue = (value) => {
        if (typeof value === "boolean") {
            return value ? (
                <span className="tick">✓</span>
            ) : (
                <span className="cross">✕</span>
            );
        }

        return value;
    };

    return (
        <div className="PricingBox2-section">

            <div className="container">

                <div className="home-box4-top">
                    <h2>Compare Our Plans</h2>
                    <p>
                        Complete list of features available in our pricing plans
                    </p>
                </div>

                <div className="pricebox2-content">

                    <table className="pricing-table">

                        <thead>
                            <tr>
                                <th></th>
                                <th>Starter</th>
                                <th>Growth</th>
                                <th>Ultimate</th>
                            </tr>
                        </thead>

                        <tbody>

                            {comparisonData.map((item, index) => (
                                <tr key={index}>

                                    <td className="feature-title">
                                        {item.feature}
                                    </td>

                                    <td>{renderValue(item.starter)}</td>

                                    <td>{renderValue(item.growth)}</td>

                                    <td>{renderValue(item.ultimate)}</td>

                                </tr>
                            ))}

                        </tbody>

                    </table>

                </div>

            </div>

        </div>
    );
}

export default PricingBox2;